import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [ReactiveFormsModule, CommonModule,MatFormFieldModule,MatInputModule, MatDatepickerModule],
  selector: 'app-milestone',
  templateUrl: './milestone.component.html',
  styleUrls: ['./milestone.component.css'],
})
export class MilestoneComponent implements OnInit {
  @Input() name = '';
  @Input() startDate = '';
  @Input() endDate = '';
  @Input() projectStartDate = '';
  @Input() projectEndDate = '';
  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  milestoneForm: FormGroup;
  constructor() {
    this.milestoneForm = new FormGroup({
      name: new FormControl(''),
      start_date: new FormControl(''),
      end_date: new FormControl(''),
    });
  }

  projectStartDateFormatted: string = '';
  projectEndDateFormatted: string = '';

  ngOnInit(): void {
    this.projectStartDateFormatted = this.formatDateString(
      this.projectStartDate
    );
    this.projectEndDateFormatted = this.formatDateString(this.projectEndDate);
    this.milestoneForm.setValue({
      name: this.name,
      start_date: this.startDate,
      end_date: this.endDate,
    });
  }

  private formatDateString(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  save() {
    this.onSave.emit(this.milestoneForm.value);
  }

  cancel() {
    this.onCLose.emit();
  }
}
